"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TableContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useSortableHeaders = _interopRequireDefault(require("./hooks/useSortableHeaders"));

var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var TableContext = _react.default.createContext({
  sort: function sort() {},
  isDnDEnabled: false,
  columnsWidth: {},
  isDragging: false,
  setIsDragging: function setIsDragging() {},
  contextId: '',
  hasDragHandlers: true,
  setHasDragHandlers: function setHasDragHandlers() {},
  fixedColumns: {}
});

exports.TableContext = TableContext;

function TableProvider(_ref) {
  var children = _ref.children,
      defaultSort = _ref.defaultSort,
      isDnDEnabled = _ref.isDnDEnabled,
      onColumnResize = _ref.onColumnResize,
      columnsWidth = _ref.columnsWidth,
      fixedColumns = _ref.fixedColumns,
      hasDragHandlers = _ref.hasDragHandlers,
      setHasDragHandlers = _ref.setHasDragHandlers,
      dragVariant = _ref.dragVariant;
  var sortableProps = (0, _useSortableHeaders.default)(defaultSort);
  var contextId = (0, _useUniqueId.default)(undefined, 'table-');

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDragging = _useState2[0],
      setIsDragging = _useState2[1];

  return _react.default.createElement(TableContext.Provider, {
    value: _objectSpread({
      onColumnResize: onColumnResize,
      fixedColumns: fixedColumns
    }, sortableProps, {
      isDnDEnabled: isDnDEnabled,
      columnsWidth: columnsWidth,
      isDragging: isDragging,
      setIsDragging: setIsDragging,
      contextId: contextId,
      hasDragHandlers: hasDragHandlers,
      setHasDragHandlers: setHasDragHandlers,
      dragVariant: dragVariant
    })
  }, children);
}

var _default = TableProvider;
exports.default = _default;